import { render, staticRenderFns } from "./BloquearTela.vue?vue&type=template&id=2fec3676&scoped=true&"
import script from "./BloquearTela.vue?vue&type=script&setup=true&lang=js&"
export * from "./BloquearTela.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fec3676",
  null
  
)

export default component.exports